export default {
  name: "Product"
};